import { BaseBillingEntity } from '/@/modules/billing/models/BaseBillingEntity';
import { BillingCard } from '/@/modules/billing/models/BillingCard';

export class BillingCustomer extends BaseBillingEntity {
  /**
   * @var {boolean}
   */
  allowDirectDebit;

  /**
   * @var {string}
   */
  autoCollection;

  /**
   * @var {string}
   */
  backupPaymentSourceId;

  /**
   * @var {string}
   */
  billingAddress;

  /**
   * @var {string}
   */
  cardStatus;

  /**
   * @var {string}
   */
  createdAt;

  /**
   * @var {string}
   */
  createdFromIp;

  /**
   * @var {string}
   */
  deleted;

  /**
   * @var {string}
   */
  email;

  /**
   * @var {string}
   */
  excessPayments;

  /**
   * @var {string}
   */
  firstName;

  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  lastName;

  /**
   * @var {string}
   */
  mrr;

  /**
   * @var {string}
   */
  netTermDays;

  /**
   * @var {string}
   */
  object;

  /**
   * @var {string}
   */
  paymentMethod;

  /**
   * @var {string}
   */
  piiCleared;

  /**
   * @var {string}
   */
  preferredCurrencyCode;

  /**
   * @var {string}
   */
  primaryPaymentSourceId;

  /**
   * @var {string}
   */
  promotionalCredits;

  /**
   * @var {string}
   */
  refundableCredits;

  /**
   * @var {string}
   */
  taxability;

  /**
   * @var {string}
   */
  unbilledCharges;

  constructor(model = {}) {
    super(model);

    this.allowDirectDebit = model.allowDirectDebit;
    this.autoCollection = model.autoCollection;
    this.backupPaymentSourceId = model.backupPaymentSourceId;
    this.billingAddress = model.billingAddress;
    this.cardStatus = model.cardStatus;
    this.card = BillingCard.mapModel(model.card);
    this.createdAt = model.createdAt;
    this.createdFromIp = model.createdFromIp;
    this.deleted = model.deleted;
    this.email = model.email;
    this.excessPayments = model.excessPayments;
    this.firstName = model.firstName;
    this.id = model.id;
    this.lastName = model.lastName;
    this.mrr = model.mrr;
    this.netTermDays = model.netTermDays;
    this.object = model.object;
    this.paymentMethod = model.paymentMethod;
    this.piiCleared = model.piiCleared;
    this.preferredCurrencyCode = model.preferredCurrencyCode;
    this.primaryPaymentSourceId = model.primaryPaymentSourceId;
    this.promotionalCredits = model.promotionalCredits;
    this.refundableCredits = model.refundableCredits;
    this.taxability = model.taxability;
    this.unbilledCharges = model.unbilledCharges;
  }
}
